import { z } from "zod";

export const formWizardSchema = z.object({
  provider: z.enum(["TYPEFORM", "ROCKET_FORM"]),
  source_id: z.string().min(1, "Source ID is required"),
  // No `name` here: both providers supply it from their own API on create.
  region_id: z.string().min(1, "Region is required"),
  department: z.string().min(1, "Department is required"),
  status: z.enum(["ACTIVE", "INACTIVE"]),
  doc_link: z.string().optional(),
  bundle_ids: z.array(z.string()).default([]),
});

export type FormWizardData = z.infer<typeof formWizardSchema>;
